import { SVGProps, Ref, forwardRef } from 'react';

export const CartFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M.49 10.489 0 5.332h2.468L5.775 1l1.113.85L4.23 5.331h7.536L9.108 1.849 10.22 1l3.307 4.332h2.47l-.491 5.157h-.002C15.131 13.866 13.708 15 9.92 15H6.076c-3.788 0-5.21-1.134-5.584-4.511z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CartFilledSize16Glyph.displayName = 'CartFilledSize16Glyph';
